import { render, staticRenderFns } from "./DriveItemsButton.vue?vue&type=template&id=fdf663ac&scoped=true&"
import script from "./DriveItemsButton.ts?vue&type=script&lang=ts&"
export * from "./DriveItemsButton.ts?vue&type=script&lang=ts&"
import style0 from "./DriveItemsButton.vue?vue&type=style&index=0&id=fdf663ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf663ac",
  null
  
)

export default component.exports